import * as wjcCore from "@grapecity/wijmo"
import "@grapecity/wijmo.cultures/wijmo.culture.ja"
import "@grapecity/wijmo.styles/wijmo.css"
import React, { useEffect } from "react"
import { Route, BrowserRouter as Router, Switch } from "react-router-dom"
import { toast } from "react-toastify"
import Auth from "./Auth"
import Main from "./Main"
import "./scss/App.scss"

import dayjs from "dayjs"
import "dayjs/locale/ja"
import { ErrorBoundary, FallbackProps } from "react-error-boundary"
import { useSelector } from "react-redux"
import Login from "./features/Login/Login"
import Settings from "./features/Settings/Settings"
import { TabletBody } from "./features/Tablet/TabletBody"
import { RootState } from "./globalStore/rootreducer"

//dayjsのロケーション確定
dayjs.locale("ja")

// wijmoライセンス設定
process.env.REACT_APP_WIJMO_LICENSE_KEY &&
  wjcCore.setLicenseKey(process.env.REACT_APP_WIJMO_LICENSE_KEY)

// toast初期設定
toast.configure()

// エラーハンドリング用のラッパー
const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => (
  <div role="alert">
    <p>Error Message</p>
    <pre>{error!.message}</pre>
    <button onClick={resetErrorBoundary}>Try again</button>
  </div>
)

function App() {
  const isTablet = useSelector((state: RootState) => state.terminal.isTablet)
  //タブレットの場合最小サイズが変わるためここで定義する
  useEffect(() => {
    if (isTablet) {
      document.body.style.minWidth = "1280px"
    } else {
      document.body.style.minWidth = "1366px"
    }
  }, [isTablet])
  return (
    <Router basename={process.env.PUBLIC_URL ?? ""}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {isTablet ? (
          <TabletBody />
        ) : (
          <Switch>
            {/* TODO:ログイン画面など、認証外のページが存在する場合 AUth外に配置する */}
            <Route path={["/login"]} component={Login} />
            <Route path={["/settings"]} component={Settings} />
            <Auth>
              <Route path="/" component={Main} />
            </Auth>
          </Switch>
        )}
      </ErrorBoundary>
    </Router>
  )
}

export default App
